import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../../images/location_new/fold2/BgCustom.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="London">
              <h2> Leverage the Expertise of Our Software Developers UK</h2>
            </div>
            <p>
              As a profound custom software development company, we have a
              professional team of custom software developers who are experts in
              building customized solutions. Having experience in the
              development of diverse custom software, our bespoke software
              developers in UK have facilitated business from multiple
              industries. We deploy the latest development practices to
              continuously innovate in the software development market and build
              something unique. Therefore, you can capitalize on the prowess of
              our bespoke software developers in UK and take the lead in your
              relevant sector with the optimal automation of your business
              operations.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
